import { useState, useEffect, useContext } from "react";
import MainLayouts from "../../Layout/MainLayouts";
import { ReactComponent as Trash } from "bootstrap-icons/icons/trash3.svg";
import { ReactComponent as PlusSquareFill } from "bootstrap-icons/icons/plus-square-fill.svg";
import { ReactComponent as PencilSquare } from "bootstrap-icons/icons/pencil-square.svg";
import { ReactComponent as Eye } from "bootstrap-icons/icons/eye.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as ChevronDown } from "bootstrap-icons/icons/chevron-down.svg";
import { ReactComponent as XCircle } from "bootstrap-icons/icons/x-circle.svg";
import { ReactComponent as Download } from "bootstrap-icons/icons/download.svg";
import { ReactComponent as Search } from "bootstrap-icons/icons/search.svg";
// import { ReactComponent as Calendar } from "bootstrap-icons/icons/calendar.svg";
import { ReactComponent as ArrowClockwise } from "bootstrap-icons/icons/arrow-clockwise.svg";
import { ReactComponent as PlusCircleFill } from "bootstrap-icons/icons/plus-circle-fill.svg";
import Spinner from "../spinner/Spinner";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import ApiServices from "../../api/ApiServices";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import CustomStyles from "../../components/utils/CustomStyles";
import CurrencyFormatter from "../../components/utils/CurrencyFormatter";
import { handleError } from "../../components/utils/AuthenticationCheck";
import AxiosApiCall from "../../api/AxiosApiCall";
import { AuthContext } from "../../AuthProvider/AuthProvider";
import formatDate from "../../components/utils/DateFormatter";
import { downloadCSVFromApi } from "../../components/utils/DownlaodCSVFromApi";

const ReturnOrder = () => {
  const [returnOrders, setReturnOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingCSV, setLoadingCSV] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [confirmationLoading, setConfirmationLoading] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedRejectedBy, setSelectedRejectedBy] = useState("");
  const { permissions } = useContext(AuthContext);

  // Date filter state
  const [filters, setFilters] = useState({
    start_date: "",
    end_date: "",
  });

  const navigate = useNavigate();

  useEffect(() => {
    const fetchReturnOrder = async () => {
      setLoading(true);
      try {
        const authData = JSON.parse(localStorage.getItem("auth"));
        const token = authData?.token;
        if (!token) {
          throw new Error("No access token found.");
        }
        const response = await axios.get(ApiServices.getReturnedOrdersByCustomer, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        });
        // console.log("Returned Orders Response:", response);
        const { status, message, data } = response.data;

        if (status === 200) {
          setReturnOrders(data.slice().reverse());
          toast.success(message, { toastId: "product-fetch-success" });

        } else {
          handleError({ response: { status, data: { message } } }, navigate);
        }
      } catch (error) {
        handleError(error, navigate);
      } finally {
        setLoading(false);
      }
    };

    fetchReturnOrder();
  }, []);

  // Handle Delete Confirmation
  const handleDeleteConfirmation = (productId) => {
    setConfirmationLoading(true);
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      setConfirmationLoading(false);
      if (result.isConfirmed) {
        handleDeleteProduct(productId);
      }
    });
  };

  // Handle Product Deletion
  const handleDeleteProduct = async (productId) => {
    const formData = {
      product_id: productId,
    };
    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) {
        throw new Error("No access token found.");
      }
      const response = await axios.delete(ApiServices.removereturnOrders, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: formData,
        withCredentials: true,
      });

      const updatedProduct = returnOrders.filter(
        (product) => product.product_id !== productId
      );
      setReturnOrders(updatedProduct);

      const { status, message } = response.data;
      if (status === 200) {
        toast.success(message);
      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (error) {
      handleError(error, navigate);
    } finally {
      setLoading(false);
    }
  };

  const handleFilter = (e) => {
    setFilterText(e.target.value);
    setResetPaginationToggle(!resetPaginationToggle);
  };

  // Handle filter changes
  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  // Check if both dates are selected
  const areDatesSelected = filters.start_date && filters.end_date;

  // Handle Rejected By selection
  const handleRejectedBySelect = (type) => {
    setSelectedRejectedBy(type);
    setIsDropdownOpen(false);
  };

  // Define Expandable Component for Actions
  const ExpandableComponent = ({ data }) => (
    <div className="flex justify-start p-4 relative">
      {permissions.some(permission => permission.name === 'order.view') && (
        <div className="mx-2 my-2 group relative">
          <Link
            to="/admin/customer/order/return/details"
            state={{ returnOrders: data }}
          >
            <Eye className="w-5 h-5 text-darkGreen3 " />
          </Link>
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block  text-darkGreen3 text-xs px-2 py-1 rounded">
            Details
          </div>
        </div>
      )}
      {permissions.some(permission => permission.name === 'order.return') && (
        <div className="mx-2 my-2 group relative">
          <Link
            to="/admin/customer/order/return/update"
            state={{ returnOrders: data }}
          >
            <PencilSquare className="w-5 h-5 text-dash4 " />
          </Link>
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block text-dash4 text-xs px-2 py-1 rounded">
            Edit
          </div>
        </div>
      )}
    </div>
  );

  const columns = [
    {
      name: "Ordered Item",
      selector: (row) => {
        if (row.order && row.order.order_items && row.order.order_items.length > 0) {
          return row.order.order_items
            .map(item => item.product?.name?.toUpperCase() || "")
            .join(", ");
        }
        return "";
      },
      sortable: true,
      width: "400px",
    },
    {
      name: "Tracking Id",
      selector: (row) => row.order.tracking_id ? row.order.tracking_id : "NOT AVIALABLE",
      sortable: true,
      width: "200px",
    },
    {
      name: "Amount",
      selector: (row) => CurrencyFormatter(row.order.total_amount),
      sortable: true,
      width: "100px",
    },
    {
      name: "Payment Method",
      selector: (row) => row.order.payment_method.toUpperCase(),
      sortable: true,
      width: "200px",
    },
    {
      name: "Rejected By",
      selector: (row) => row.admin?.fullname.toUpperCase() || "NOT AVAILABLE",
      sortable: true,
      width: "200px",
    },
    {
      name: "Ordered date",
      selector: (row) => formatDate(row.created_at),
      sortable: true,
      width: "200px",
    },
  ];

  // Filter data based on search text, rejected by, AND date range
  const filteredItems = returnOrders.filter((item) => {
    // Search filter
    const search = filterText.toLowerCase();
    const searchable = [
      item.user?.firstname,
      item.user?.lastname,
      item.user?.email,
      item.admin?.fullname,
      item.admin?.email,
      item.order?.payment_method,
      item.order?.tracking_id,
      item.order?.order_items?.map(i => i.product?.name).join(" "),
    ].join(" ").toLowerCase();
    const matchesFilterText = searchable.includes(search);

    // Filter by rejected by (admin/customer)
    const matchesRejectedBy = !selectedRejectedBy ||
      (selectedRejectedBy === "admin" && item.admin) ||
      (selectedRejectedBy === "customer" && !item.admin);

    // Filter data based on date range
    let matchesDateRange = true;
    if (areDatesSelected) {
      const itemDate = new Date(item.created_at);
      const startDate = new Date(filters.start_date);
      const endDate = new Date(filters.end_date);
      endDate.setHours(23, 59, 59, 999);
      matchesDateRange = itemDate >= startDate && itemDate <= endDate;
    }

    return matchesFilterText && matchesRejectedBy && matchesDateRange;
  });

  const data = filteredItems.map((returnOrders) => ({
    order: returnOrders.order ? returnOrders.order : "NOT AVAILABLE",
    tracking_id: returnOrders.order.tracking_id ? returnOrders.order.tracking_id : "NOT AVAILABLE",
    total_amount: returnOrders.total_amount ? returnOrders.total_amount : "NOT AVAILABLE",
    payment_method: returnOrders.payment_method ? returnOrders.payment_method : "NOT AVAILABLE",
    user: returnOrders.user ? returnOrders.user : "NOT AVAILABLE",
    user: returnOrders.user?.lastname ? returnOrders.user?.lastname : "NOT AVAILABLE",
    user: returnOrders.user?.firstname ? returnOrders.user?.firstname : "NOT AVAILABLE",
    created_at: returnOrders.created_at,
  }));

  // Sort data based on creation date
  const sortedData = [...data].sort((a, b) => {
    const dateA = new Date(a.created_at);
    const dateB = new Date(b.created_at);
    return dateB - dateA;
  });

  // Handle CSV Download - Server-side filtered by date
  const handleDownloadCSV = async () => {
    if (!areDatesSelected) {
      toast.error("Please select both start and end dates to download CSV");
      return;
    }

    // Validate date range
    const startDate = new Date(filters.start_date);
    const endDate = new Date(filters.end_date);

    if (startDate > endDate) {
      toast.error("Start date must be before end date");
      return;
    }

    // limit date range to a year
    const daysDiff = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
    if (daysDiff > 365) {
      toast.error("Date range cannot exceed 1 year");
      return;
    }

    setLoadingCSV(true);

    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;

      if (!token) {
        toast.error("No access token found");
        return;
      }

      // Prepare download payload - adjust API endpoint as needed
      const downloadPayload = {
        start_date: filters.start_date,
        end_date: filters.end_date,
        download: 1,
      };

      // Create filename with date range
      const startDateFormatted = filters.start_date.replace(/-/g, '_');
      const endDateFormatted = filters.end_date.replace(/-/g, '_');
      const filename = `returned_orders_${startDateFormatted}_to_${endDateFormatted}.csv`;


      await downloadCSVFromApi(
        ApiServices.getReturnedOrdersByCustomer,
        downloadPayload,
        token,
        {
          filename: filename,
          columnsToRemove: [], // Add sensitive columns to exclude 
          maxRows: 50000
        }
      );

    } catch (error) {
      console.error("Download error:", error);
      handleError(error, navigate);
      if (error.message && error.message.includes("CSV")) {
        toast.error("Failed to process CSV file");
      } else if (error.message && error.message.includes("network")) {
        toast.error("Network error during download");
      }
    } finally {
      setLoadingCSV(false);
    }
  };

  // Clear date filters
  const handleClearDates = () => {
    setFilters({
      start_date: "",
      end_date: "",
    });
    toast.success("Date filters cleared");
  };

  return (
    <div>
      <MainLayouts>
        <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
          <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
            <nav className="bg-gray-200 py-0 px-4 rounded-lg">
              <ol className="list-none p-0 inline-flex mb-2">
                <li className="flex items-center">
                  <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                    Rejected Items
                  </p>
                  <ChevronRightIcon />
                </li>
                <li className="flex items-center">
                  <p className="text-orange1">List</p>
                </li>
              </ol>
            </nav>
          </section>

          {/* Filter Controls Section - Responsive */}
          <div className="pb-4 bg-white dark:bg-gray-900">
            <div className="hidden md:flex flex-wrap items-center gap-3">
              {/* Search Input Field with Icon */}
              <div className="relative w-full sm:w-1/2 my-2 mb-4 sm:mb-0">
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
                  <input
                    type="search"
                    className="mb-4 block w-full pl-10 pr-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                    placeholder="Search ..."
                    value={filterText}
                    onChange={handleFilter}
                  />
                </div>
              </div>

            </div>

            {loading ? (
              <Spinner />
            ) : (
              <DataTable
                columns={columns}
                data={filteredItems}
                pagination
                highlightOnHover
                striped
                customStyles={CustomStyles}
                noDataComponent={
                  <div className="text-center py-8">
                    {areDatesSelected ?
                      "No return orders found for the selected date range" :
                      "No return orders found"
                    }
                  </div>
                }
                expandableRows
                expandableRowsComponent={ExpandableComponent}
              />
            )}
          </div>
        </div>
      </MainLayouts>
    </div>
  );
};

export default ReturnOrder;
